import { render } from "./GoogleSearch.vue?vue&type=template&id=5e8976f3"
import script from "./GoogleSearch.vue?vue&type=script&lang=js"
export * from "./GoogleSearch.vue?vue&type=script&lang=js"

import "@/assets/styles.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__